<template>
    <MainContent title="Compañia">
        <template v-slot:header>
            <div>
                <h3>Datos fiscales personalizados para el evento: {{ evento ? evento.name : '' }} </h3>
            </div>            
        </template>
        <template v-slot:content>
            <transition name="fade" mode="out-in">
                <ContentOrLoading>
                    <template v-if="evento">
                        
                        <FormComponent :evento="evento" @actualizado="getEvento(evento_id)" />

                        <div class="row">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <UserViewerComponent :evento="evento" @actualizar="getEvento(evento_id)" /> 
                        
                    </template>                    
                </ContentOrLoading>
            </transition>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import ContentOrLoading from "@/components/backend/components/ContentOrLoading";
import FormComponent from '@/components/backend/eventos/compania/FormComponent';
import UserViewerComponent from '@/components/backend/eventos/compania/UserViewerComponent';

export default {
    props: ['evento_id'],
    data() {
        return {
            evento: null,
            email: ''
        }
    },
    created() {
        this.getEvento(this.evento_id)
    },
    methods: {
        getEvento(evento_id) {
            const data = {
                evento_id: evento_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.show'), data).then(res => {
                this.evento = res.data.data;
            });
        }
    },
    components: {
        MainContent, ContentOrLoading, FormComponent, UserViewerComponent
    }
}
</script>
